export default __webpack_public_path__ + "src/images/packages/zannier-hotels-omaanda/7316014f38d23c52e5c07bd911a56745-1.jpg";